import api from "./api";

const PettyCashPaymentsReportService = {
  getReport: async (params) => {
    const response = await api.get("/pettyCashPaymentsReport/getReport", {
      params: {
        companyId: params.companyId || undefined,
        employeeId: params.employeeId || undefined,
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,
        page: params.page || 1,
        limit: params.limit || 10,
      },
    });

    return response.data;
  },
};

export default PettyCashPaymentsReportService;
